export default "__VITE_ASSET__COsUPpcC__"